import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { useTranslation } from 'react-i18next';
import styles from './Background.module.scss';

const Background = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    threshold: 0.3,
    triggerOnce: true
  });

  const languages = t('about.languages.items', { returnObjects: true });
  const education = t('about.education.items', { returnObjects: true });

  return (
    <section ref={ref} className={styles.background} id="background">
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={inView ? { opacity: 1, y: 0 } : {}}
        transition={{ duration: 0.8 }}
        className={styles.content}
      >
        <div className={styles.languages}>
          <h3>{t('about.languages.title')}</h3>
          <div className={styles.languageGrid}>
            {languages.map((lang, index) => (
              <motion.div
                key={index}
                className={styles.language}
                initial={{ opacity: 0, x: -20 }}
                animate={inView ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <span className={styles.name}>{lang.language}</span>
                <span className={styles.level}>{lang.level}</span>
              </motion.div>
            ))}
          </div>
        </div>

        <div className={styles.education}>
          <h3>{t('about.education.title')}</h3>
          {education.map((edu, index) => (
            <motion.div
              key={index}
              className={styles.timelineItem}
              initial={{ opacity: 0, x: -20 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className={styles.timelineDot} />
              <div className={styles.timelineContent}>
                <span className={styles.period}>{edu.period}</span>
                <h4>{edu.degree}</h4>
                <p>{edu.school}</p>
                {edu.additional && <p className={styles.additional}>{edu.additional}</p>}
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Background; 